// src/pages/RulesPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import './RulesPage.css';

const RulesPage = () => {
  return (
    <div className="container rules-page">
      <div className="rules-header">
        <h1>CanvasMC Rules</h1>
        <p className="rules-subtitle">TLDR; Use common sense and be respectful.</p>
      </div>

      <div className="rules-content">
        <section className="rules-section">
          <h2>On The Canvas</h2>
          <div className="rules-list">
            <div className="rule-item">
              <span className="rule-number">1.</span>
              <div className="rule-text">
                <strong>Remember That You're Identifiable</strong>
                <p>Your username is attached to the blocks that you paint. Keep this in mind as you ponder the rest of these rules. Finding out who painted this or that inappropriate content is as easy as clicking on a block with the block info tool. We reserve the right to discipline accordingly.</p>
              </div>
            </div>

            <div className="rule-item">
              <span className="rule-number">2.</span>
              <div className="rule-text">
                <strong>No Offensive Art</strong>
                <p>Hate symbols, slurs, or inappropriate art (this includes references to violence, explicit content, or demonic imagery) will be removed and the user will be punished.</p>
              </div>
            </div>

            <div className="rule-item">
              <span className="rule-number">3.</span>
              <div className="rule-text">
                <strong>Grief Intentionally</strong>
                <p>Painting over other people's art is a part of the game. But running around randomly spewing paint everywhere excessively for no reason may result in punishments.</p>
              </div>
            </div>

            <div className="rule-item">
              <span className="rule-number">4.</span>
              <div className="rule-text">
                <strong>No Bots or Automation</strong>
                <p>All painting must be done manually. Using bots, scripts, or external tools to paint is strictly prohibited.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="rules-section">
          <h2>Chat & Conduct Rules</h2>
          <div className="rules-list">
            <div className="rule-item">
              <span className="rule-number">5.</span>
              <div className="rule-text">
                <strong>Keep Chat Friendly</strong>
                <p>No harassment, spam, excessive caps, or toxic behavior in chat. Treat everyone with respect.</p>
              </div>
            </div>

            <div className="rule-item">
              <span className="rule-number">6.</span>
              <div className="rule-text">
                <strong>No Advertising</strong>
                <p>Do not advertise other servers, Discord servers, or external services.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="rules-section">
          <h2>Enforcement & Penalties</h2>
          <div className="rules-list">
            <div className="rule-item">
              <span className="rule-number">9.</span>
              <div className="rule-text">
                <strong>Canvas Penalties</strong>
                <p>The rules stated above in 'On The Canvas' apply to all players while on the server. Breaking them will result in a temporary or permanent restriction from painting blocks, or banishment from the server itself.</p>
              </div>
            </div>

            <div className="rule-item">
              <span className="rule-number">8.</span>
              <div className="rule-text">
                <strong>Chat Penalties</strong>
                <p>Breaking the rules underlined above in 'Chat & Conduct Rules' will result in temporary or permanent restrictions from server or discord chat.</p>
              </div>
            </div>

            <div className="rule-item">
              <span className="rule-number">8.</span>
              <div className="rule-text">
                <strong>Multiple Offenses</strong>
                <p>First offenses will usually be lighter however the punishment will match the crime as best we can determine. Staff have discretion in applying penalties.</p>
              </div>
            </div>

            <div className="rule-item">
              <span className="rule-number">10.</span>
              <div className="rule-text">
                <strong>Appeals</strong>
                <p>If you believe you were banned unfairly, you may appeal through our Discord server. Appeals are reviewed within 48 hours.</p>
              </div>
            </div>

            <div className="rule-item">
              <span className="rule-number">11.</span>
              <div className="rule-text">
                <strong>Staff Decisions are Final</strong>
                <p>Respect moderator and administrator decisions. Arguing or trying to avoid punishments will result in harsher penalties.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="rules-section gameplay-tips">
          <h2>Gameplay Advice</h2>
          <div className="tips-grid">
            <div className="tip-card">
              <h3>Compete on Leaderboards</h3>
              <p>Track your progress on the <Link to="/leaderboards">leaderboards</Link>. Paint more blocks to climb the ranks!</p>
            </div>

            <div className="tip-card">
              <h3>Verify Your Account</h3>
              <p><Link to="/verify">Link your account</Link> to access your profile, stats, and website features.</p>
            </div>

            <div className="tip-card">
              <h3>Cosmetics</h3>
              <p>Use <code>/nc</code> and <code>/icon</code> to customize your username tag.</p>
            </div>

            <div className="tip-card">
              <h3>Flying</h3>
              <p>Get around the Canvas faster by double jumping to fly. Use <code>/speed (1-5)</code> to change your flying speed.</p>
            </div>
          </div>
        </section>

        <section className="rules-footer">
          <h3>Questions or Concerns?</h3>
          <p>
            If you have questions about the rules or need to report a violation, contact a staff member in-game or on our Discord server.
          </p>
          <div className="footer-note">
            <strong>Note:</strong> These rules are subject to change (and will be made more robust overtime). Major updates will be announced on our <Link to="https://discord.gg/TCznh2NkB3">Discord</Link>.
          </div>
        </section>
      </div>
    </div>
  );
};

export default RulesPage;